;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Unsubscribe = Backbone.Model.extend({
		url: 'unsubscribe',
		defaults: {
			"token"        : "",
			"email"        : "",
			"notification" : ""
		}
	});

}(window, APP, Backbone, Marionette, $, _));